import { Component, input } from '@angular/core';
import { fadeIn } from '@core/motion/motion.animations';
import { LiquidLoaderComponent } from '@shared/components/liquid-loader/liquid-loader.component';

/**
 * Loading de tela inteira com o loader de vidro do Admin (agj-liquid-loader) e mensagem opcional. Substitui o
 * `agj-one-loading-app` (Lottie + barra) no link público.
 */
@Component({
  selector: 'agj-loading-app',
  imports: [LiquidLoaderComponent],
  templateUrl: './loading-app.component.html',
  styleUrl: './loading-app.component.scss',
  animations: [fadeIn]
})
export class LoadingAppComponent {
  public message = input<string>('');
}
